export default __webpack_public_path__ + "barcelona-9e72d3a07e0f434610abd36f7f3ff5f8.bundle.jpg";